import { render, staticRenderFns } from "./HomeSectionInfinite.vue?vue&type=template&id=13d3c4d2&scoped=true&"
import script from "./HomeSectionInfinite.vue?vue&type=script&lang=js&"
export * from "./HomeSectionInfinite.vue?vue&type=script&lang=js&"
import style0 from "./HomeSectionInfinite.vue?vue&type=style&index=0&id=13d3c4d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d3c4d2",
  null
  
)

export default component.exports